import React, { useEffect, useState, useContext } from "react"
import { useNavigate } from "react-router-dom"

import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  TextField,
  InputLabel,
  Button,
  Typography,
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  Tooltip,
} from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import ExpandMore from "@mui/icons-material/ExpandMore"
// ESTILO DE FORMULARIO DE BUSQUEDA PROOVEDORES
const CodigoProvBox = styled(Box)({
  gridArea: "CodigoProv",
})
const IdProvBox = styled(Box)({
  gridArea: "IdProv",
})
const EstadoProvBox = styled(Box)({
  gridArea: "EstadoProv",
})
const NombreProvBox = styled(Box)({
  gridArea: "NombreProv",
})
// Contenedor de campos de busqueda
const ContainerProv = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(6, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "CodigoProv CodigoProv IdProv IdProv EstadoProv EstadoProv "
    "NombreProv NombreProv NombreProv NombreProv NombreProv NombreProv "
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(3, 1fr)",
    gridTemplateAreas: `
      "CodigoProv  IdProv EstadoProv"
      "NombreProv NombreProv NombreProv"
    `,
  },
}))
const FiltrosProovedores = ({
  codigoProv,
  idProv,
  estadoProv,
  nombreProv,
  setCodigoProv,
  setIdProv,
  setEstadoProv,
  setNombreProv,
  expanded,
  setExpanded,
  error,
  setError,
  handleExpandAccordion,
  Estados,
}) => {
  const handleNumericInput = (value, setValue) => {
    // Allow empty value, integers, or decimals
    if (/^\d*\.?\d*$/.test(value)) {
      setValue(value)
      setError(false) // No error if the input is valid
    } else {
      setError(true) // Show error if the input is invalid
    }
    console.log(idProv)
  }
  const handleCodigoProv = (event) => {
    setCodigoProv(event.target.value)
  }
  useEffect(() => {
    setCodigoProv(codigoProv)
    console.log(codigoProv)
  }, [codigoProv])
  const handleNombreProv = (event) => {
    setNombreProv(event.target.value)
  }
  useEffect(() => {
    setNombreProv(nombreProv)
    console.log(nombreProv)
  }, [nombreProv])
  useEffect(() => {
    setIdProv(idProv)
    console.log(idProv)
  }, [idProv])
  return (
    <div style={{ paddingBottom: "10px" }}>
      <Accordion expanded={expanded} onChange={handleExpandAccordion} slotProps={{ heading: { component: "h2" } }}>
        <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
            Criterios de búsqueda
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ContainerProv>
            <CodigoProvBox>
              <InputLabel>Codigo</InputLabel>
              <TextField fullWidth value={codigoProv} onChange={handleCodigoProv} />
            </CodigoProvBox>
            <IdProvBox>
              <InputLabel>Identificacion</InputLabel>
              <FormControl fullWidth error={error}>
                <TextField
                  value={idProv}
                  onChange={(e) => handleNumericInput(e.target.value, setIdProv)}
                  error={error} // Set error state in TextField
                  helperText={error ? "Por favor ingresa solo valores numéricos." : ""}
                />
                {error && <FormHelperText>El valor ingresado no es válido.</FormHelperText>}
              </FormControl>
            </IdProvBox>
            <EstadoProvBox>
              <InputLabel>Estado</InputLabel>
              <Select
                fullWidth
                labelId="estadoProvCB"
                value={estadoProv.value}
                onChange={(e) => {
                  const selectedValue = e.target.value
                  const clienteestado = Estados.find((estado) => estado.value === selectedValue)
                  setEstadoProv(clienteestado)
                  //   clearAll(tipoPregunta)
                }}
              >
                {Estados.map((estado) => (
                  <MenuItem key={estado.value} value={estado.value}>
                    {estado.description}
                  </MenuItem>
                ))}
              </Select>
            </EstadoProvBox>
            <NombreProvBox>
              <InputLabel>Nombre</InputLabel>
              <TextField fullWidth value={nombreProv} onChange={handleNombreProv} />
            </NombreProvBox>
          </ContainerProv>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default FiltrosProovedores
